import React, {useState, useEffect} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {getPromoterService} from "../../../../services/getPromoterService";
import {getOrderFromPaymentId} from "../../../../services/orderService";
import Loader from "../../../../components/Loader/Loader";
import Header from "../Header/Header";
import Footer from "../../../../components/Footer";
import Breadcrumbs from "../../../../components/Checkout/Breadcrumbs/BreadCrumbs";
import OrderStatus from "../order/OrderStatus";
import {Helmet, HelmetProvider} from "react-helmet-async";
import ReactGA from "react-ga4";

const Enjoy = () => {
    const currentStep = 3;

    const [searchParams] = useSearchParams();
    const paymentId = searchParams.get("external_reference")
    const [promoter, setPromoter] = useState(null);
    const [loading, setLoading] = useState(true);
    const [order, setOrder] = useState(null);
    const navigate = useNavigate();
    const [haveTime, setHaveTime] = useState(false);

    useEffect(() => {
        const fetchPromoter = async () => {
            try {
                const promoter = await getPromoterService();
                setPromoter(promoter);
                const order = await getOrderFromPaymentId(paymentId);
                if (order.booking.status === "created") navigate("/");
                setOrder(order);
                setHaveTime(order.booking.quotation.has_available_time_spots)

                setLoading(false);
                if(process.env.NODE_ENV === "production" ) {
                    ReactGA.event(
                        'Sale', {
                            category: promoter?.alias ? promoter?.alias : 'Convertion',
                            action: order.booking.status,
                            label: order?.booking?.quotation?.title, // optional,
                        });
                }
            } catch (e) {
                localStorage.removeItem("tp_order_id")
                navigate("/");
            }
        };
        fetchPromoter();
    }, [navigate, paymentId]);


    if (loading) return <Loader/>;

    const currentUrl = window.location.protocol + "//" + window.location.host +  window.location.pathname + window.location.search

    return (
        <HelmetProvider>
            <Helmet>
                <title>{order?.booking?.quotation?.title}</title>
                <link rel="icon" type="image/png" href={`${promoter.logoURL}`} sizes="16x16"/>
                <meta property="og:title" content={order?.booking?.quotation?.title}/>
                <meta data-react-helmet="true" name="description"
                      content={order?.booking?.quotation?.itinerary?.description}/>
                <meta data-react-helmet="true" property="og:description"
                      content={order.booking?.quotation?.itinerary?.description}/>
                <meta data-react-helmet="true" property="og:url" content={currentUrl}></meta>
            </Helmet>
            <Header promoter={promoter}></Header>
            <div className="enjoy__container">
                <Breadcrumbs currentStep={currentStep} orderStatus={order?.booking?.status} noGoBack="true"></Breadcrumbs>
                <div className="main-content">
                    <OrderStatus order={order} haveTime={haveTime}></OrderStatus>
                </div>
            </div>
            <Footer promoter={promoter}></Footer>
        </HelmetProvider>
    );
};

export default Enjoy;
